import { render, staticRenderFns } from "./ResourcesFilters.vue?vue&type=template&id=6ac9f41a&scoped=true&"
import script from "./ResourcesFilters.vue?vue&type=script&lang=ts&"
export * from "./ResourcesFilters.vue?vue&type=script&lang=ts&"
import style0 from "./ResourcesFilters.vue?vue&type=style&index=0&id=6ac9f41a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac9f41a",
  null
  
)

export default component.exports